// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__d7dQ8","version":"Menu_version__z6K-C"};